import React, { Component } from 'react';
import Helmet from "react-helmet";

import Payout from '../../components/payout/';

const PayoutPage = () => (
	<div className="payout-index">
		<Helmet>
			<title>ИРМ - Выплата</title>
		</Helmet>
		<Payout />
	</div> 
)

export default PayoutPage;
 


// WEBPACK FOOTER //
// ./src/routes/payout/index.js